<template>

  <div v-if="redirectPopupData.isToProcessPopup" class="to-process">
    <div class="transition-modal">
      <h3 class="transition-modal__title">{{redirectPopupData.header}}</h3>
      <p class="transition-modal__text" v-html="redirectPopupData.subheader"></p>
      <a><button class="button form-buttons__next transition-modal__btn-redirect" @click="toProcessRequest">{{redirectPopupData.button}}</button></a>
      <div class="transition-modal__additionla-text">{{redirectPopupData.additionalText}}</div>
    </div>
  </div>

  <div v-else id="squeeze-block">
    <div>
      <div class="squeeze-block__title">
        <h1>{{redirectPopupData.header}}</h1>
        <p v-html="redirectPopupData.subheader"></p>
      </div>
      <!-- logos -->
      <div class="squeeze-block__logos">
        <div class="squeeze-block__logos-wrap">
          <img v-if="redirectPopupData.logo" :src="redirectPopupData.logo" alt="" class="squeeze-block__logos-crezu">
        </div>
        <div class="squeeze-block__logos-arrows">
          <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
              <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
            <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
              <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
            <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
              <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
            <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
              <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
        </div>
        <div class="squeeze-block__logos-wrap">
          <img :src="redirectPopupData.lenderLogo" alt="" class="squeeze-block__logos-mfo">
        </div>
      </div>
      <p v-if="redirectPopupData.amount" class="squeeze-block__cash">{{redirectPopupData.amountHint}}: <span id="squeeze-block__cash">{{redirectPopupData.currency}}{{redirectPopupData.amount}}</span></p>
      <div v-html="redirectPopupData.amountAdditional"></div>
      <p v-if="redirectPopupData.period" class="squeeze-block__cash">{{redirectPopupData.periodHint}}: <span>{{redirectPopupData.period}}</span></p>
      <label v-if="redirectPopupData.checkbox" class="form-checkbox__wrap">
        <input v-model="checked" type="checkbox">
        <span class="form-checkbox" :class="{'redirect-checkbox-pulsating': !checked}"></span>
        <p v-html="redirectPopupData.checkbox"></p>
      </label>
      <a class="ui-button reserve-redirect-button" :href="redirectPopupData.redirectUrl" @click="redirectButtonClick"><button class="form-buttons__next" name="redirect_to_api" :disabled="!redirectApproved">{{redirectPopupData.button}}</button></a>
      <a class="ui-button to-process-button" v-if="redirectPopupData.buttonToProcessRequest" @click="toProcessRequest"><button class="form-buttons__next">{{redirectPopupData.buttonToProcessRequest}}</button></a>
      <p v-if="redirectPopupData.additionalText" class="squeze_additionalText" v-html="redirectPopupData.additionalText"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { titleAndFavChanger } from '../helpers'
import { openLink } from '../store/helpers/redirect-actions'

let tToRedirect
let tToProcess

export default {
  name: 'RedirectPopup',
  data: function () {
    return {
      checked: false,
      checkboxError: false,
      titleAndFavData: {}
    }
  },
  computed: {
    ...mapState({
      redirectPopupData: state => state.redirectPopupData
    }),
    redirectApproved () {
      let approved = true
      if (this.redirectPopupData.disableAutoRedirect && this.redirectPopupData.checkbox && !this.checked) approved = false
      return approved
    }
  },
  mounted () {
    if (this.redirectPopupData.isToProcessPopup) {
      this.titleAndFavData = titleAndFavChanger({})
      console.log('this is toProcess popup. Redirect had been in new tab')
    } else if (this.redirectPopupData.disableAutoRedirect) {
      console.warn('auto redirect disabled, go to process after 20 sec')
      tToProcess = setTimeout(() => {
        this.toProcessRequest()
      }, this.redirectPopupData.timeoutToProcessRequest)
    } else {
      tToRedirect = setTimeout(() => {
        this.$store.dispatch('successRedirectPrepare', 'API')
        this.$store.commit('CHANGE_PRELOADER', true)
        openLink(this.redirectPopupData.redirectUrl)
      }, this.redirectPopupData.timeout)
    }
  },
  methods: {
    redirectButtonClick: function (e) {
      if (!this.redirectApproved) {
        e.preventDefault()
      } else {
        this.$store.dispatch('successRedirectPrepare', 'API')
        console.log('timeouts is cleared')
        clearTimeout(tToRedirect)
        clearTimeout(tToProcess)
        this.$store.commit('CHANGE_PRELOADER', true)
      }
    },
    toProcessRequest: function () {
      clearTimeout(tToProcess)
      this.$store.commit('SHOW_REDIRECT_POPUP', false)
      this.$store.dispatch('getDataFromBackend', +1)
      if (this.redirectPopupData.isToProcessPopup) {
        titleAndFavChanger(this.titleAndFavData)
        this.$store.dispatch('sendCrezuEvent', { id: 12 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/redirect";

.to-process {
  display: flex;
  justify-content: center;
  padding-top: 100px;
}

.transition-modal {
  display: flex;
  flex-direction: column;
  width: calc(100vw - 30px);
  max-width: 510px;
  padding: 40px 30px 54px 30px;
  box-shadow: 0 0 18px rgba(65, 13, 118, 0.27);
  border-radius: 10px;
  text-align: left;

  @media (max-width: 767px) {
    padding: 35px 20px 40px 20px;
  }

  &__title {
    font-size: 30px;
    line-height: 40px;
    font-weight: 500;
    color: #1c1c1c;
    margin-bottom: 15px;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 28px;
      font-weight: 700;
      margin-bottom: 10px;
    }
  }

  &__text {
    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
    color: #1c1c1c;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  &__btn-redirect {
    height: 60px;
    margin-top: 20px;
  }
  &__additionla-text {
    margin-top: 35px;
    font-size: 14px;
    @media (max-width: 767px) {
      margin-top: 20px;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RedirectPopup.vue